/** 검사 성적서 비고 첨부 (공인기관 성적서 대체 등) */

export interface RemarkAttachmentLike {
  attachmentId: number;
  fileName: string;
  contentType?: string | null;
}

interface Props {
  attachments?: RemarkAttachmentLike[];
  pendingFiles?: File[];
  editable?: boolean;
  emptyText?: string;
  onDownload?: (file: RemarkAttachmentLike) => void;
  onDeleteSaved?: (file: RemarkAttachmentLike) => void;
  onRemovePending?: (index: number) => void;
}

function InspectionRemarkFiles({
  attachments = [],
  pendingFiles = [],
  editable = false,
  emptyText = '비고 첨부파일이 없습니다.',
  onDownload,
  onDeleteSaved,
  onRemovePending,
}: Props) {
  if (attachments.length === 0 && pendingFiles.length === 0) {
    return <p style={{ margin: 0, fontSize: 12, color: '#98a2b3' }}>{emptyText}</p>;
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'flex-start' }}>
      {attachments.map((file) => (
        <div
          key={file.attachmentId}
          style={{
            width: 180,
            border: '1px solid #d0d5dd',
            background: '#fff',
            padding: 6,
            fontSize: 12,
          }}
        >
          <button
            type="button"
            className="is-ghost"
            style={{ padding: 0, border: 'none', color: '#1a5fb4', textAlign: 'left' }}
            onClick={() => onDownload?.(file)}
          >
            {file.fileName}
          </button>
          {editable && onDeleteSaved ? (
            <button
              type="button"
              className="is-danger"
              style={{ marginTop: 4, display: 'block' }}
              onClick={() => onDeleteSaved(file)}
            >
              삭제
            </button>
          ) : null}
        </div>
      ))}
      {editable
        ? pendingFiles.map((file, index) => (
            <div
              key={`pending-${index}-${file.name}`}
              style={{
                width: 180,
                border: '1px dashed #98a2b3',
                background: '#f8fafc',
                padding: 6,
                fontSize: 12,
              }}
            >
              <div style={{ wordBreak: 'break-all', color: '#445062' }}>{file.name}</div>
              <span style={{ color: '#98a2b3', fontSize: 11 }}>저장 시 업로드</span>
              {onRemovePending ? (
                <button
                  type="button"
                  className="is-danger"
                  style={{ marginTop: 4, display: 'block' }}
                  onClick={() => onRemovePending(index)}
                >
                  제거
                </button>
              ) : null}
            </div>
          ))
        : null}
    </div>
  );
}

export default InspectionRemarkFiles;
